module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0112.jpg?v=8f9bfb2c";